import apiClient from './api_client_requests';

export default async payload => {
    console.log(payload);
    let result = await apiClient.apiMethod({
        method: 'PlayerUpdate',
        args: {
            first_name: payload.first_name,
            last_name: payload.last_name,
            email: payload.email,
            email_confirm: payload.email_confirm,
            address1: payload.address1,
            address2: payload.address2,
            city: payload.city,
            state: payload.state,
            zip: payload.zip,
            area_phone1: payload.area_phone1,
            prefix_phone1: payload.prefix_phone1,
            suffix_phone1: payload.suffix_phone1,
            area_phone2: payload.area_phone2,
            prefix_phone2: payload.prefix_phone2,
            suffix_phone2: payload.suffix_phone2,
            dob_month: payload.dob_month,
            dob_day: payload.dob_day,
            dob_year: payload.dob_year,
            password: payload.password,
            verify_password: payload.verify_password,
            optin1: payload.optin1,
            optin2: payload.optin2,
        },
    });

    let player = result;

    console.log(result);
    if (!result.success) {
        return {
            errors: result.error,
            success: false,
            player: {
                name: player.first_name + ' ' + player.last_name,
                email: player.email,
                first_name: player.first_name,
                last_name: player.last_name,
                email_confirm: player.email,
                player_id: player.id,
                address1: player.address1,
                address2: player.address2,
                city: player.city,
                state: player.state,
                zip: player.zip,
                phone1: player.phone1,
                area_phone1: player.phone1.split('-')[0],
                prefix_phone1: player.phone1.split('-')[1],
                suffix_phone1: player.phone1.split('-')[2],
                phone2: player.phone2,
                area_phone2: player.phone2.split('-')[0],
                prefix_phone2: player.phone2.split('-')[1],
                suffix_phone2: player.phone2.split('-')[2],
                dob_year: player.dob_year,
                dob_month: player.dob_month,
                dob_day: player.dob_day,
                optins: player.lottery_optins,
                optin1: player.selected_optins[0] ? true : false,
                optin2: player.selected_optins[1] ? true : false,
            },
        };
    } else {
        return {
            success: true,
            player: {},
        };
    }
};
